import React from "react";
import { Segment, Divider } from "semantic-ui-react";
import { SemanticContainer, SemanticSegment } from "./styled";

import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import ListarIndicacoes from "../../../../components/Admin/Eventos/ListagemIndicacoes";

const ListaIndicacoes = (props) => {
  return (
    <>
      <AdminMenu />
      <SemanticContainer>
        <h2>Indicações</h2>
        <Divider />
        <Segment>
          <ListarIndicacoes />
        </Segment>
      </SemanticContainer>
      <SemanticContainer>
        <SemanticSegment>
          Grupo Voitto <i class="copyright outline icon"></i>2020
        </SemanticSegment>
      </SemanticContainer>
    </>
  );
};

export default withRouter(ListaIndicacoes);
